import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';

// Routing
import { AppRoutingModule } from './app-routing.module';

// Shared
import { SharedModule } from './shared/shared-common/shared.module'
import { SharedComponentsModule } from './shared/shared-common-components/shared-components.module';

//services
import { BreadcrumbService } from './services/breadcrumb/breadcrumb.service';
import { NonceService } from './services/nonce/nonce.service';
import { AuthService } from './services/auth/auth.service';
import { ConsoleLoggerService } from './services/console-logger/console-logger.service';

@NgModule({
  declarations: [
    AppComponent    
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule,
    SharedComponentsModule,    
  ],
  providers: [
    BreadcrumbService,
    NonceService,
    AuthService,
    ConsoleLoggerService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
